import MapperContainer from './MapperContainer';
import Loading from '../../Shared/Loading';
import WorkflowEngineHeader from '../../WorkflowEngine/WorkflowEngineHeader';
import { WorkflowEngineConfig } from '../../WorkflowEngine/workflowEngineDictionary';

export default {
  container: <MapperContainer />,
  loadingView: (
    <>
      <WorkflowEngineHeader />
      <Loading sx={{ marginTop: '70px' }} />
    </>
  )
} as WorkflowEngineConfig;
